// extracted by mini-css-extract-plugin
export default {"mediumDesktop":"(max-width: 1180px)","mediumMobile":"(max-width: 480px)","overlayThreeUpWrapper":"OverlayThreeUp_overlayThreeUpWrapper__yYn+6"};